import { Section } from "views/applications-id-report/components/Section";
import VerifiedIcon from "shared/icons/verified-icon.svg?react";
import { ColumnDef } from "@tanstack/react-table";
import { VerifiedIncomeReport } from "types/landlord/reports";

import { UniversalTable } from "views/applications-id-report/slices/IncomeReportSlice/components/UniversalTable";
import { VerifiedNetEarningsColumns } from "views/applications-id-report/slices/IncomeReportSlice/components/VerifiedNetEarningsTableExpander/VerifiedNetEarningsColumns";
import { formatToCurrency } from "utils/currency";

interface VerifiedNetEarningsProps {
  report?: VerifiedIncomeReport;
}

export const VerifiedNetEarnings = ({ report }: VerifiedNetEarningsProps) => {
  return (
    <Section
      sectionTitle="Verified net earnings"
      icon={<VerifiedIcon />}
      maxWidth="none"
    >
      <UniversalTable
        rowHeight={64}
        tableColumns={VerifiedNetEarningsColumns as ColumnDef<unknown, any>[]}
        tableData={report?.net_income_summary || []}
        sectionName="Verified net earnings"
        mobileRow={(row) => {
          return (
            <div className="flex gap-2 justify-between">
              <p className="text-sm font-bold text-content-1000">
                {formatToCurrency(
                  row.original.total_net || {
                    cents: 0,
                    currency: "USD"
                  }
                )}
              </p>

              <p className="text-sm text-content-500">{row.original.month}</p>
            </div>
          );
        }}
      />
    </Section>
  );
};
